import MDBox from 'components/MDBox';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import DashboardOverview from 'components/DashboardOverview';
import React from 'react';

const Dashboard = () => {
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox sx={{ pt: 4, pb: { xs: 2, sm: 3 }, px: { xs: 1, sm: 3 } }}>
                <DashboardOverview />
            </MDBox>
        </DashboardLayout>
    );
};

export default Dashboard;